/*  ========================================================================
    # Main JavaScript File
    ========================================================================  */

/* eslint-disable no-unused-vars */

import 'tether';
import 'popper.js';
import 'bootstrap';
import 'leaflet';
import 'leaflet-gesture-handling';
import 'hammerjs';
import Starkmacher from './starkmacher';
import Bfsg from './bfsg';

document.addEventListener('DOMContentLoaded', () => {
  Starkmacher.init();
  Bfsg.init();
});
